"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthResponseInterceptor = void 0;
const ResponseInterceptor_1 = require("./ResponseInterceptor");
class AuthResponseInterceptor extends ResponseInterceptor_1.ResponseInterceptor {
    constructor(authStatusManager, axios) {
        super(axios);
        this.authStatusManager = authStatusManager;
        this.authStatusManager = authStatusManager;
    }
    onFulfilled(response) {
        return __awaiter(this, void 0, void 0, function* () {
            return response;
        });
    }
    onRejected(error) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!(error === null || error === void 0 ? void 0 : error.config)) {
                throw new Error("Request config missing!!!");
            }
            const status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
            // A 403 on a request that opted out (allowForbidden) is a feature gate, not
            // an auth failure — let the caller handle it instead of forcing a logout.
            const allowForbidden = (_b = error.config) === null || _b === void 0 ? void 0 : _b.allowForbidden;
            if (status === 403 && allowForbidden) {
                return Promise.reject(error);
            }
            if (status && [401, 403].includes(status)) {
                yield this.authStatusManager.logoutUser();
                return this.rejectResponse(error === null || error === void 0 ? void 0 : error.config, "Not authorized by server", "FORCE_LOGOUT");
            }
            return Promise.reject(error);
        });
    }
}
exports.AuthResponseInterceptor = AuthResponseInterceptor;
